
























































import { Component, Vue } from 'vue-property-decorator'
import RoleView from '@/components/Common/RoleView.vue'
import AllRoleGuide from '@/components/AllRoleGuide.vue'
import Advertisement from '@/components/Common/Advertisement.vue'
import HeadlineBorder from '@/components/Utils/headline/HeadlineBorder.vue'

@Component({
  components: {
    RoleView,
    AllRoleGuide,
    Advertisement,
    HeadlineBorder
  }
})
export default class Rule extends Vue {}
